export const PAGES = {
  profile: {
    path: 'profile',
    name: 'profile',
    title: 'Профиль компании',
  },
  payers: {
    path: 'payers',
    name: 'payers',
    title: 'Плательщики',
  },
  documents: {
    path: 'documents',
    name: 'documents',
    title: 'Документы',
  },
  photoGallery: {
    path: 'photo-gallery',
    name: 'photo-gallery',
    title: 'Фотогалерея'
  },
  notifications: {
    path: 'notifications',
    name: 'notifications',
    title: 'Уведомления',
  },
  orders: {
    path: 'orders',
    name: 'orders',
    title: 'Заказы',
    retail: {
      path: 'retail',
      name: 'orders-retail',
      title: 'Розничные заказы',
      to: '/account/orders/retail',
    },
    dealer: {
      path: 'dealer',
      name: 'orders-dealer',
      title: 'Заказы от дилеров',
      to: '/account/orders/dealer',
    },
    supplier: {
      path: 'supplier',
      name: 'orders-supplier',
      title: 'Заказы поставщику',
      to: '/account/orders/supplier',
    },
    new_order: {
      path: 'new-order',
      name: 'new-order',
      title: 'Новый заказ поставщику',
    },
  },
  reclamations_supplier: {
    path: 'reclamations/supplier',
    name: 'reclamations-supplier',
    title: 'Рекламации поставщику',
  },
  reclamations_dealers: {
    path: 'reclamations/dealers',
    name: 'reclamations-dealers',
    title: 'Рекламации от дилеров',
  },
  wholesale: {
    name: 'wholesale-orders-edit',
  },
  warehouse: {
    path: 'warehouse',
    name: 'warehouse',
    title: 'Наличие и сроки изготовления',
    to: '/account/warehouse'
  },
  online: {
    path: 'online',
    name: 'online',
    title: 'Заказать онлайн',
  },
  markup: {
    path: 'markup',
    name: 'markup',
    title: 'Наценка на модели',
  },
  employees: {
    path: 'employees',
    name: 'employees',
    title: 'Сотрудники',
  },
  balance: {
    path: 'balance',
    name: 'balance',
    title: 'Баланс',
  },
  invoices: {
    path: "invoices",
    name: "invoices",
    title: "Список РНК"
  },
  special_prices: {
    path: "reports/special-prices",
    name: "special-prices",
    title: "Спеццены и акции"
  },
  dealers: {
    path: 'dealers',
    name: 'dealers',
    title: 'Дилеры',
  },
  settings: {
    path: 'settings',
    name: 'settings',
    title: 'Настройки',
  },
  reports: {
    path: 'reports',
    name: 'reports',
    title: 'Товары',
  },
  reports_orders: {
    path: 'reports_orders',
    name: 'reports_orders',
    title: "Заказы"
  },
  report_selling: {
    path: 'selling',
    name: 'reports-selling',
    title: 'Продажи'
  },
  shippings: {
    path: 'shippings',
    name: 'shippings',
    title: 'Отгрузки'
  },
  reports_by_materials_zgi: {
    path: "reports_by_materials_zgi",
    name: "reports_by_materials_zgi",
    title: "Материалы в ГИ",
  },
  report_selling_zgi: {
    path: 'reports/selling/zgi',
    name: 'reports-selling-zgi',
    title: 'Готовые изделия',
  },
  report_selling_cut: {
    path: 'reports/selling/cut',
    name: 'reports-selling-cut',
    title: 'Отрезы',
  },
  report_selling_opt: {
    path: 'reports/selling/opt',
    name: 'reports-selling-opt',
    title: 'Оптовые позиции',
  },
};
